export const DIRECTORY_REDUX_FORM_NAME = 'searchDirectory'
export const DIRECTORY_RESULTS_PER_PAGE = 30
